import { split, map, fromPairs } from 'ramda'

const decode = (str) => decodeURIComponent(str.trim())

export default (cookieStr) => {
  const chunks = split(';', cookieStr)
  const keyValuePairs = map((chunk) => map(decode, split('=', chunk)), chunks)
  return fromPairs(keyValuePairs)
}
